import {AbstractTCIWebSocketService, ITCIWebSocketService} from "@tci/common";
import {Injectable} from "@angular/core";

/**
 * Base Websocket Service
 */
@Injectable()
export class NgWebSocketService extends AbstractTCIWebSocketService implements ITCIWebSocketService {

    /**
     * get singleton instance
     */
    public static getInstance(): NgWebSocketService {
        if (!AbstractTCIWebSocketService.instance) {
            AbstractTCIWebSocketService.instance = new NgWebSocketService();
        }
        return AbstractTCIWebSocketService.instance;
    }

    /**
     * constructor
     * @param name
     */
    private constructor() {
        super();
    }


}
